import { JSConn } from "@/utilities/js-conn";
import {
  CWorkOrderTask,
  CWorkOrderTaskLineItem,
} from "@/store/modules/workOrderTasks";

import {
  ref,
  reactive,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

import StatusIndicator from "@/components/StatusIndicator/StatusIndicator.vue";

import { buildSubmitButton } from "@/utilities/form-helpers";
import { buildFormEditTask } from "@/models/WorkOrderTask";
import { map as Rmap } from "ramda";

import { prettifyWorkOrderTaskStatus } from "@/models/WorkOrderTask";

export default defineComponent({
  name: "workOrderTasks",
  components: {
    StatusIndicator,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let task = reactive({
      content: "",
      created_at: null,
      work_order_id: null,
    });

    let workOrderTasks = computed(() => {
      return $store.getters.workOrderTasks as CWorkOrderTask[];
    });

    let workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    let isFieldWorker = computed(() => {
      return $store.getters.isFieldWorker;
    });

    const taskClassObject = (task: CWorkOrderTask) => {
      let taskCompleted = false;
      if (task.status === "completed") {
        taskCompleted = true;
      } else {
        taskCompleted = false;
      }

      return {
        "completed-task": taskCompleted,
      };
    };

    let { submitButtonText, submitting } = buildSubmitButton();

    submitButtonText.value = "Submit";

    let {
      editingTask,
      editTask,
      editingTaskId,
      cancelEditTask,
    } = buildFormEditTask();

    const localEditTask = (task: CWorkOrderTask) => {
      return editTask("edit", editingTaskId, editingTask, task);
    };

    const localCancelEditTask = (task: CWorkOrderTask) => {
      return cancelEditTask(editingTaskId, task);
    };

    const submitEditTask = (evt: any) => {
      evt.preventDefault();
      submitButtonText.value = "Submitting...";
      submitting.value = true;

      const jsConnWorkOrderTask = new JSConn();

      jsConnWorkOrderTask.formParams = {
        id: editingTask.id,
        status: editingTask.status,
        start_date: editingTask.start_date,
        completed_date: editingTask.completed_date,
      };

      let jsConnTaskLineItems = Rmap(item => {
        const tempJsConn = new JSConn();
        tempJsConn.formParams = {
          id: item.id,
          quantity: item.quantity,
          item_date: item.item_date,
        };

        return $store.dispatch("updateWorkOrderTaskLineItem", tempJsConn);
      }, editingTask.work_order_task_line_items);

      const dataPromises = [
        $store.dispatch("updateWorkOrderTask", jsConnWorkOrderTask),
        ...jsConnTaskLineItems,
      ];

      Promise.all(dataPromises).then(() => {
        editingTaskId.value = "";
        submitButtonText.value = "Submit";
        submitting.value = false;
        // tell the parent that the data has changed
        ctx.emit("tasksChanged");
        return Promise.resolve();
      });
    };

    return {
      workOrderTasks,
      workOrder,
      isFieldWorker,

      taskClassObject,

      task,

      localEditTask,
      localCancelEditTask,

      editingTaskId,
      editingTask,
      submitEditTask,
      submitButtonText,
      submitting,

      prettifyWorkOrderTaskStatus,
    };
  },
});
